import { render } from "./Customizable.vue?vue&type=template&id=a40e5b6e"
import script from "./Customizable.vue?vue&type=script&lang=js"
export * from "./Customizable.vue?vue&type=script&lang=js"

import "./Customizable.vue?vue&type=style&index=0&id=a40e5b6e&lang=css"
script.render = render

export default script